import { StyledMaxWidth, TaxIdentifierInput } from '@dreryk/react-components';

import { visitSettlementTranslationKeys } from '../../../translations';
import { VisitSettlementFormController } from '../VisitSettlementForm';

const TAX_IDENTIFIER_FOR_RECEIPT_FIELD_NAME = 'taxIdentifierForReceipt';

const t = visitSettlementTranslationKeys.shared.form.taxIdentifierForReceipt;

type TaxIdentifierFieldProps = Pick<VisitSettlementFormController, 'register'>;

export const TaxIdentifierForReceiptField = (props: TaxIdentifierFieldProps): JSX.Element => {
   return (
      <StyledMaxWidth maxWidth={133}>
         <TaxIdentifierInput
            placeholder={t.placeholder}
            label={t.label}
            controller={props.register(TAX_IDENTIFIER_FOR_RECEIPT_FIELD_NAME)}
            testId={TAX_IDENTIFIER_FOR_RECEIPT_FIELD_NAME}
         />
      </StyledMaxWidth>
   );
};
